import React, { useRef } from 'react';
import { SubModule, Permission, Module } from '../roles/rolePermission/RolePermission';
import Toggle from '../common/toggle/Toggle';
import AccordionExpandIcon from '../svgIcons/AccordionExpandIcon';
import AccordionCollapseIcon from '../svgIcons/AccordionCollapseIcon';
import styles from './PermissionAccordion.module.css';

interface AccordionProps {
    module: Module;
    content: SubModule[];
    active: boolean;
    onToggle: (id: string) => void;
    updatePermissions: (moduleId: string, subModuleId: string, permissionKey: string, checked: boolean) => void;
}

const PermissionAccordion = ({ module, content, active, onToggle, updatePermissions }: AccordionProps) => {
    const contentEl: React.RefObject<HTMLDivElement> = useRef(null);
    return (
        <div className={styles.questionnarieContent}>
            <button className={`${styles.accordion} ${active ? styles.active : ''}`} onClick={() => onToggle(module?.moduleId)}>
                <div className={styles.accordion_leftContainer}>
                    {active ? <AccordionExpandIcon /> : <AccordionCollapseIcon />}
                    <p className={styles.accordion__title}>{module?.name}</p>
                </div>
                <div className={`${styles.permissionList} ${active ? styles.active : ''}`}>
                    <div className={styles.permission}>all</div>
                    <div className={styles.permission}>create</div>
                    <div className={styles.permission}>read</div>
                    <div className={styles.permission}>update</div>
                    <div className={styles.permission}>delete</div>
                </div>
            </button>
            <div
                ref={contentEl}
                style={{ maxHeight: `${active ? `${contentEl.current?.scrollHeight}px` : '0px'}` }}
                className={styles.accordionContent}>
                <div>
                    <div className={styles.permissionToggleList}>
                        {
                            content?.map((value: SubModule, index: number) => {
                                return <div key={index} className={styles.content}>
                                    <div className={styles.leftContainer}>
                                        <span>{value?.name}</span>
                                    </div>

                                    <div className={styles.rightContainer}>
                                        <div key={'all'} className={styles.toggleContainer}>
                                            <Toggle
                                                checked={value?.permissions?.every((permission: Permission) => permission?.isAllowed)}
                                                onChange={(checked: boolean) => {
                                                    updatePermissions(module.moduleId, value?.moduleId, 'all', checked)
                                                }}
                                            />
                                        </div>
                                        {value?.permissions
                                            ?.sort((a, b) => {
                                                const order = ["create", "read", "update", "delete"];
                                                return order.indexOf(a.name) - order.indexOf(b.name);
                                            })
                                            .map((permission: Permission, perIndex: number) => {
                                                return (
                                                    <div key={perIndex} className={styles.toggleContainer}>
                                                        <Toggle
                                                            checked={permission?.isAllowed}
                                                            onChange={(checked: boolean) =>
                                                                updatePermissions(module.moduleId, value.moduleId, permission.name, checked)
                                                            }
                                                        />
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PermissionAccordion;
